var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('LoadingCard'):_c(_vm.userDashboard,{tag:"component",attrs:{"current-user":_vm.currentUser}})}
var staticRenderFns = []

export { render, staticRenderFns }